import useSWR from 'swr'
import { requestGet } from '../utils/services'
import { useAuthContext } from '../context/AuthProvider'

// const useUserProgramme = (programmeId?: string, userId?: string) => {
//   const { user } = useAuthContext()
//   console.log({ programmeId, user },"this is the the useUserProgramme")
//   const userProgrammeKey = programmeId && (userId || user?.id)
//     ? `/api/programmes/${programmeId}?populate[logo]=*&populate[programme_types][populate][sub_modules][populate][sections][populate][sub_module][populate][sub_module_submissions][filters][user][documentId][$eq]=${userId || user?.id}&populate[programme_types][populate][sub_modules][populate][sections][populate][sub_module][populate][sub_module_submissions][populate][user]=*&populate[programme_types][populate][sub_modules][populate][sections][populate][sub_module][populate][sub_module_submissions][populate][sub_module]=*&populate[programme_types][populate][sub_modules][populate][sections][populate][sub_module][populate][sub_module_submissions][populate][section][populate]=*`
//     : null

//   const { data, mutate } = useSWR(userProgrammeKey, (url: string) => requestGet(url), {
//     revalidateOnFocus: false
//   })

//   return {
//     userProgramme: data,
//     updateProgramme: () => mutate(),
//     isLoading: !data
//   }
// }

const useUserProgramme = (programmeId?: string, userId?: string) => {
  const { user } = useAuthContext()
  const targetUserId = userId || user?.documentId

  const userProgrammeKey =
    programmeId && targetUserId
      ? `/api/submodule-submissions/programme/${programmeId}/user-submissions/${targetUserId}`
      : null

  const { data, mutate } = useSWR(userProgrammeKey, (url: string) => requestGet(url), {
    revalidateOnFocus: false
  })
  console.log({data})

  return {
    userProgramme: data?.data?.[0] ?? data,
    updateProgramme: () => mutate(),
    isLoading: !data
  }
}
// const useUserProgramme = (programmeId?: string, userId?: string) => {
//   const { user } = useAuthContext()
//   const targetUserId = userId || user?.id

//   const userProgrammeKey = programmeId && targetUserId
//     ? `/api/submodule-submissions/programme/${programmeId}/user-submissions/${targetUserId}`
//     : null

//   // Debug: log the exact URL
//   console.log('[useUserProgramme] key:', userProgrammeKey)
//   console.log({programmeId, userId, targetUserId})

//   const { data, error, mutate } = useSWR(userProgrammeKey, async (url: string) => {
//     console.log('[useUserProgramme] fetching:', url)
//     try {
//       const result = await requestGet(url)
//       console.log('[useUserProgramme] result:', result)
//       return result
//     } catch (err: any) {
//       console.error('[useUserProgramme] ERROR:', err.response?.status, err.response?.data)
//       throw err
//     }
//   }, {
//     revalidateOnFocus: false
//   })

//   console.log({ data, error, isLoading: !data && !error })

//   return {
//     userProgramme: data,
//     updateProgramme: () => mutate(),
//     isLoading: !data && !error
//   }
// }
export default useUserProgramme
